import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow } from "date-fns";
import { tr } from "date-fns/locale";

interface Message {
  id: number;
  name: string;
  surname: string;
  email: string;
  phone?: string;
  message: string;
  web3forms_submission_id?: string;
  created_at: Date;
  read: boolean;
}

interface RecentMessagesProps {
  messages: Message[];
  onViewMessage: (id: number) => void;
}

export function RecentMessages({ messages, onViewMessage }: RecentMessagesProps) {
  return (
    <Card className="col-span-full lg:col-span-2">
      <CardHeader>
        <CardTitle>Son Mesajlar</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {messages.length === 0 ? (
            <p className="text-center text-muted-foreground py-4">Henüz mesaj bulunmuyor.</p>
          ) : (
            messages.map((message) => {
              const excerpt = message.message ? 
                (message.message.length > 100 ? message.message.substring(0, 100) + '...' : message.message) : 
                "Mesaj içeriği yok";
              
              return (
                <div 
                  key={message.id} 
                  className="flex items-start space-x-4 p-3 rounded-lg hover:bg-muted/50 cursor-pointer"
                  onClick={() => onViewMessage(message.id)}
                >
                  <div className="flex-1 space-y-1">
                    <div className="flex items-center justify-between">
                      <p className="font-medium text-sm">{message.name} {message.surname}</p>
                      <span className="text-xs text-muted-foreground">
                        {formatDistanceToNow(message.created_at, { locale: tr, addSuffix: true })}
                      </span>
                    </div>
                    <p className="text-xs text-muted-foreground line-clamp-2">{excerpt}</p>
                  </div>
                  {!message.read && (
                    <Badge variant="default" className="rounded-full mt-1 h-2 w-2 p-0" />
                  )}
                </div>
              );
            })
          )}
        </div>
      </CardContent>
    </Card>
  );
}
